<template>
    <li class="result-item">
        <div class="row">
            <div class="col-4">
                <span v-html="this.$sanitize(description)"></span>
            </div>
            <div class="col-6">
              <span  v-if="!showHtml" v-bind:class="{error: failed}"> {{ error }} </span>
              <span v-else v-bind:class="{error: failed}" v-html="error">  </span>
            </div>
            <div class="col-2 text-right">
                <loading-spinner v-if="pending" v-bind:loading="pending" />
                <span v-if="!pending" class="result-icon" v-bind:class="{ success: success, failed: failed }"></span>
            </div>

        </div>
    </li>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';
import * as Enums from '../libs/enums.js';

export default {
  name: 'BatchResult',
  components: {
    'loading-spinner': LoadingSpinner
  },
  props: {
    description: String,
    result: String,
    error: String,
    showHtml: {
      default: false,
      required: false
    }
  },
  data: function () {
    return {

    };
  },
  methods: {
  },
  computed: {
    success () {
      return this.result === Enums.ResultEnum.SUCCESS;
    },
    failed () {
      return this.result === Enums.ResultEnum.FAILED;
    },
    pending () {
      return this.result === Enums.ResultEnum.PENDING;
    }
  }
};
</script>
<style lang="scss" scoped>
.result-item {
    list-style: none;
    border-bottom: 1px solid #efefef;
}
.result-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    &.success {
        background: url('../assets/checkmark.png') center center no-repeat;
        background-size: 24px;
    }
    &.failed {
        background: url('../assets/error.png') center center no-repeat;
        background-size: 24px;
    }
}
.error {
    color: red;
}
</style>
